var map = {
	"./bs_t-1_reflect-stitch_blk.png": 278546,
	"./bs_t-1_reflect-stitch_blu.png": 545468,
	"./bs_t-1_reflect-stitch_cml.png": 451935,
	"./bs_t-1_reflect-stitch_crk.png": 667893,
	"./bs_t-1_reflect-stitch_grn.png": 563756,
	"./bs_t-1_reflect-stitch_lgd.png": 362106,
	"./bs_t-1_reflect-stitch_lsl.png": 917214,
	"./bs_t-1_reflect-stitch_nvy.png": 142122,
	"./bs_t-1_reflect-stitch_orn.png": 125316,
	"./bs_t-1_reflect-stitch_pnk.png": 969078,
	"./bs_t-1_reflect-stitch_ppl.png": 155411,
	"./bs_t-1_reflect-stitch_red.png": 878666,
	"./bs_t-1_reflect-stitch_sax.png": 405039,
	"./bs_t-1_reflect-stitch_wht.png": 201284,
	"./bs_t-1_reflect-stitch_ylw.png": 256861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74342;